export enum EmployerType {
  Ambulant = 'A',
  DentalPractice = 'DP',
  DoctorOffice = 'D',
  Hospice = 'Ho',
  Hospital = 'H',
  Intensive = 'I',
  IntensiveAmbulant = 'IA',
  Leasing = 'L',
  NursingHome = 'S',
  Other = '0',
  Physiotherapy = 'P',
  RehabClinic = 'R',
  UniversityHospital = 'UH',
  PrivateClinic = 'PC',
  MedicalCareCenter = 'MC',
  OutpatientPractice = 'OP',
}

export const PRAXIA_EMPLOYER_TYPE = [EmployerType.DentalPractice, EmployerType.DoctorOffice, EmployerType.Physiotherapy];

export const DOCIA_EMPLOYER_TYPE = [
  EmployerType.Hospital,
  EmployerType.DentalPractice,
  EmployerType.RehabClinic,
  EmployerType.UniversityHospital,
  EmployerType.PrivateClinic,
  EmployerType.MedicalCareCenter,
  EmployerType.OutpatientPractice,
];
